import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import * as Highcharts from 'highcharts/highcharts';
import { AssistantChatChart } from '../../interfaces/assistant-chat.interface';
import { ColorService } from '../../services/color/color.service';
import { chartOptions } from './assistant-chat.chart-options';

@Component({
  selector: 'assistant-chat-chart',
  template: '<div #container class="tw-w-full"></div>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssistantChatChartComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input({ required: true }) public block: AssistantChatChart;
  @ViewChild('container', { static: true }) private container: ElementRef<HTMLDivElement>;

  private readonly colors = inject(ColorService).defaultColors;
  private chart?: Highcharts.Chart;

  public ngAfterViewInit(): void {
    this.draw();
  }

  public ngOnChanges(): void {
    if (this.chart) {
      this.draw();
    }
  }

  public ngOnDestroy(): void {
    this.chart?.destroy();
  }

  private draw(): void {
    this.chart?.destroy();
    this.chart = Highcharts.chart(this.container.nativeElement, chartOptions(this.block, this.colors));
  }
}
